var map = {
	"./onAnimationEnd.js": "8G+B",
	"./onTransitionEnd.js": "nnxO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wZ80";


//////////////////
// WEBPACK FOOTER
// ./src/core/js/polyfills (\.js)$
// module id = wZ80
// module chunks = 1